import { takeEvery } from 'redux-saga/effects';
import { LOAD_STATUS, SET_LOCALE } from '../actions';
import { AUTHORIZED_MODULE, SYSTEM_MODULE } from '../../../configs/moduleNames';
import { AUTHORIZED_CHECK } from '../../Authorized/actions';
import { SUCCESSFUL } from '../../../configs/actionNames';

import setLocale from './setLocale';
import loadStatus from './loadStatus';

export default function* watchSystem() {
  yield takeEvery(SYSTEM_MODULE + SET_LOCALE, setLocale);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL, loadStatus);
  yield takeEvery(SYSTEM_MODULE + LOAD_STATUS, loadStatus);
}
